import { ButtonSize, ButtonVariation } from "components/Button/Button";

export const defaultButtonProps = {
    size: "default" as ButtonSize,
    variation: "dark" as ButtonVariation,
};

export const inlineButtonProps = {
    size: "small",
    variation: "white",
};
